import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fapsActions } from './faps.actions';
import { catchError, debounceTime, map, of, switchMap } from 'rxjs';
import { ErrorResponse } from '@core/models';
import { FapService } from '@api/backend';

@Injectable()
export class FapsEffects {

  public loadFeed = createEffect(() => {
    return this.actions$.pipe(
      ofType(fapsActions.loadFeed),
      switchMap(({ t, c, r, q, a, np = true, ads = true, p, ps = 3 }) =>
        this.fapService.getFapListFapGet(t, c, r, q, a, np, ads, p, ps).pipe(
          map(({ data }) => fapsActions.loadFeedSuccess({ data })),
          catchError((error: unknown) => of(fapsActions.loadFeedFailure({ error: error as ErrorResponse }))),
        )),
    );
  });

  public loadById = createEffect(() => {
    return this.actions$.pipe(
      ofType(fapsActions.loadItem),
      debounceTime(10),
      switchMap(({ fapId }) =>
        this.fapService.getFapFapFapIdGet(fapId).pipe(
          map(({ data }) => fapsActions.loadItemSuccess({ data })),
          catchError((error: unknown) => of(fapsActions.loadItemFailure({ error: error as ErrorResponse }))),
        )),
    );
  });

  public loadFeedAfterLoadById = createEffect(() => {
    return this.actions$.pipe(
      ofType(fapsActions.loadItemSuccess),
      map(({ data }) => fapsActions.loadFeed({ r: data.fap_id })),
    );
  });

  constructor(
    private actions$: Actions,
    private fapService: FapService,
  ) { }


}
